module.exports = __webpack_public_path__ + "static/media/IGDTUW2.c66922c5.jpg";